import Client from './Client';

export default class CommonClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取log
   */
  async getLog(data) {
    const res = await this.client.post('/api/common/log/page', data);
    return res;
  }

  /**
   * 获取账号列表
   */
  async getProvice() {
    const res = await this.client.post('/api/province/listTreeSon');
    return res;
  }

  /**
   * 校验手机号
   *
   */
  async checkMobile(data) {
    const res = await this.client.post('/api/user/checkMobilePhone', data);
    return res;
  }

  /**
   * 查询机构下拉列表
   */
  async agencyListName() {
    const res = await this.client.post('/api/agency/listName');
    return res;
  }

  /**
   * 查询购买过商品的机构列表
   */
  async listNameByPointsProductOrder() {
    const res = await this.client.post('/api/points/listNameByPointsProductOrder');
    return res;
  }

  /**
   * 查询购买过商品的机构列表
   */
  async counselorCouponQuery(data) {
    const res = await this.client.post('/api/points/counselorCouponQuery', data);
    return res;
  }

  /**
   * 查询cdn 参数
   * 仅做返回链接
   */
  async aliCdnDirEnum() {
    const res = await this.client.get('/api/ali/oss/sign/getSign?aliOssDirEnum=VIDEO');
    return res;
  }

  /**
   * 查询 oss 参数
   *
   */
  async aliOssDirEnum() {
    const res = await this.client.get('/api/ali/oss/sign/getSign?aliOssDirEnum=VIDEO&useOssHost=true');
    return res;
  }

  /**
   * 上传文件、图片、视频
   *
   */
  async uploadFile(path, data, config) {
    const res = await this.client.upload(path, data, config);
    return res;
  }
}